import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from '@react-google-maps/api';
import {
  styled,
  Text,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import axios from 'axios';
import React, {Component, KeyboardEvent} from 'react';
import DealerCard from './dealer-card';
import {DealerInterface} from '../types';

const FullWidthDiv = styled.div`
  display: grid;
  grid-gap: ${(props) => props.theme.size.grid002};
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  height: calc(100vh - 120px);
  max-height: 800px;
  margin-top: 3rem;

  @media screen and (min-width: 768px) {
    display: grid;
    grid-gap: ${(props) => props.theme.size.dynamic0050};
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr;
    height: calc(100vh - 120px);
    max-height: 500px;
  }
`;

const containerStyle = {width: '100%', height: '100%'};

const DealerList = styled.div`
  padding: 0 !important;
  padding-top: 0.5rem !important;
  .container {
    max-width: initial;
  }

  overflow: auto;
  margin-top: 2rem;
  @media (min-width: 768px) {
    max-height: 500px;
    margin-top: 0;
  }

  .container {
    padding-top: 0.5rem;
  }

  .placeholder-dealers {
    margin-bottom: 15px;
    font-size: 1.2rem;
    text-align: left;
    line-height: 1.2;
  }

  .dealer-card {
    margin: 0;
    margin-bottom: 10px;
    font-size: var(--textappearances-copy200-fontsize);
    line-height: var(--textappearances-copy200-lineheight);
    letter-spacing: var(--textappearances-copy200-letterspacing);

    .custom-control {
      display: flex;
      justify-content: flex-start;
      text-align: left;
      padding: 0;
    }

    // .btn-pill {
    //   font-size: var(--textappearances-copy150-fontsize) !important;
    //   line-height: var(--textappearances-copy150-lineheight);
    //   letter-spacing: var(--textappearances-copy150-letterspacing);
    //   &:focus {
    //     outline: #4CC7F4 solid 2px;
    //     outline-offset: 2px;
    //   }
    // }

    .row {
      position: relative;
    }
    input[type='radio'] {
      width: 1px;
      height: 1px;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    .dealer-label {
      display: flex;
      align-items: center;
      text-align: left;
      &:focus {
        outline: 2px solid #4cc7f4;
        outline-offset: 2px;
      }
    }
    .dealer-radio {
      margin-right: 12px;
      width: 24px;
      height: 24px;
      position: relative;
      &::before,
      &::after {
        content: ' ';
        width: 24px;
        height: 24px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
      }
      &::before {
        border: 1px solid #001e50;
        background-color: #fff;
      }
    }
    input[type='radio'] {
      &:checked {
        & ~ .dealer-label {
          .dealer-radio {
            &::after {
              background-image: none;
              background-color: #001e50;
              width: 12px;
              height: 12px;
            }
          }
        }
      }
      &:focus {
        & ~ .dealer-label {
          outline: 2px solid #4cc7f4;
          outline-offset: 2px;
        }
      }
    }

    .row {
      // margin: 0 15px;
      font-family: $VWText;
      justify-content: left;
      transition: all 0.2s ease-in-out 0s;

      &.name {
        color: rgb(0, 30, 80);

        label,
        span {
          cursor: pointer;
        }

        &:hover {
          color: rgb(26, 115, 232);
        }

        &:focus {
          outline: 2px solid #4cc7f4;
          outline-offset: 2px;
        }
      }

      &.name,
      &.phone {
        font-family: $VWText-Bold;
      }

      &.distance i {
        margin-right: 10px;
      }

      &.phone {
        text-align: left;
        display: flex;
        text-decoration: none;
        margin-top: 10px;

        a {
          display: block;
          flex: 0 0 auto;
          text-align: left;
          color: rgb(0, 30, 80) !important;
          border-bottom: 1px solid rgb(0, 30, 80);
          transition: all 0.2s ease-in-out 0s;
          position: relative;
          &:focus {
            &::before {
              content: '';
              width: calc(100% + 12px);
              height: calc(100% + 12px);
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              border: #4cc7f4 solid 2px;
            }
            outline: none;
            // outline: 2px solid #4cc7f4;
            // outline-offset: 2px;
          }
          &:hover {
            text-decoration: none;
          }
        }
      }

      &.address {
        text-align: left;
      }

      &.cta {
        margin-top: 10px;
        text-align: right;
      }
    }
  }

  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

const Row = styled.div`
  font-family: $VWText;
  justify-content: left;
  transition: all 0.2s ease-in-out 0s;
  position: relative;
  max-width: none !important;
  margin: 0;

  &.name {
    color: rgb(0, 30, 80);

    label,
    span {
      cursor: pointer;
    }

    &:hover {
      color: rgb(26, 115, 232);
    }

    &:focus {
      outline: 2px solid #4cc7f4;
      outline-offset: 2px;
    }
  }

  &.name,
  &.phone {
    font-family: $VWText-Bold;
  }

  &.distance i {
    margin-right: 10px;
  }

  &.phone {
    text-align: left;
    display: flex;
    text-decoration: none;
    margin-top: 10px;

    a {
      display: block;
      flex: 0 0 auto;
      text-align: left;
      color: rgb(0, 30, 80) !important;
      border-bottom: 1px solid rgb(0, 30, 80);
      transition: all 0.2s ease-in-out 0s;
      position: relative;
      &:focus {
        &::before {
          content: '';
          width: calc(100% + 12px);
          height: calc(100% + 12px);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border: #4cc7f4 solid 2px;
        }
        outline: none;
        // outline: 2px solid #4cc7f4;
        // outline-offset: 2px;
      }
      &:hover {
        text-decoration: none;
      }
    }
  }

  &.address {
    text-align: left;
  }

  &.cta {
    margin-top: 10px;
    text-align: right;
  }
`;

const MapContainer = styled.div`
  .gm-style-iw-chr {
    display: none;
  }
`;

const InfoDisplay = styled.div`
  width: 195px;
  margin: 10px 5px 5px;
  text-align: center;
  .title {
    font-family: $VWText-Bold;
    font-size: 16px;
    color: #001e50;
    line-height: 20px;
    font-weight: 500;
  }
  label {
    font-family: $VWText;
    font-size: 14px;
    line-height: 24px;
  }
  a {
    padding: 13px 15px 14px 15px;
  }
`;

const GeneralContainer = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`;

const options = {
  fullscreenControl: false,
  mapTypeControl: false,
  zoomControl: false,
  streetViewControl: false,
  disableDoubleClickZoom: true,
  scrollwheel: false,
  disableDefaultUI: true,
  setMapOnAll: null,
  clickableIcons: false,
  tabIndex: '-1',
  className: 'locator-map',
  ariaLabel: 'Map containing dealer locations',
  ariaHidden: 'true',
  role: 'presentation',
  keyboardShortcuts: false
};

interface LocatorMapContainerInterface {
  dealers: DealerInterface[];
  requestLabel: string;
  placeholderDealersHeadline: string;
  center: google.maps.LatLng | google.maps.LatLngLiteral | undefined;
  searchMade: boolean;
  invalidZip: boolean;
  searchCallback: (postalCode?: string) => Promise<void>;
  currentLocale: string;
  tracking: any;
  secretBaseUrl?: string;
}

export class LocatorMapContainer extends Component<LocatorMapContainerInterface> {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
    dealers: [],
    activeDealer: {} as DealerInterface,
    center: {lat: 43.64636, lng: -79.41781},
    currentLocale: undefined,
    dealerUrl: '',
    dealerRequestDisabled: true,
    selectedDealer: '',
    apiKey: undefined,
  };

  markers = [];

  componentDidMount() {
    const baseUrl = this.props.secretBaseUrl ?? "";
    axios.get(`${baseUrl}/google`).then(res => {
      const apiKey = (res as any).data?.apiKey;
      this.setState({apiKey});
    })
  }

  onMarkerClick = (props: any, marker: any, _e: any) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      center: {lat: props.latitude, lng: props.longitude},
      selectedDealer: props.id,
      activeDealer:
        this.state.dealers[`${props.latitude},${props.longitude}` as any],
    });
  };

  onMapClicked = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
        activeDealer: {} as DealerInterface,
        selectedDealer: '',
      });
    }
  };

  onDealerSelect = (dealer: DealerInterface, index: number) => {
    this.setState({
      selectedPlace: dealer,
      activeMarker: this.markers[index],
      showingInfoWindow: true,
      center: {lat: dealer.latitude, lng: dealer.longitude},
      selectedDealer: dealer.id,
      activeDealer:
        this.state.dealers[`${dealer.latitude},${dealer.longitude}` as any],
    });

    const data = {
      eventInfo: {
        brand: 'passenger',
      },
      environment: {
        featureAppId: 'TireStorageLocator-D6-CA',
      },
      partner: {
        informationBnr: dealer.dealer_id,
        informationName: dealer.name,
        informationDepartment: undefined,
        informationZIP: dealer.postal,
        onlinePaymentOption: undefined,
        appointmentSystemName: undefined,
        appointmentSystemUtilization: false,
      },
      process: {
        StepName: 'Dealer Selection',
      },
      link: {
        url: window.location.href,
        name: dealer.name,
      },
    };
    this.props.tracking.track('VWBasic_DealerSelect_Click', data);
  };

  onKeyDown = (e: KeyboardEvent, dealer: DealerInterface, index: number) => {
    if (
      e.code === 'Enter' ||
      e.nativeEvent.code == 'Enter' ||
      e.code === 'Space' ||
      e.nativeEvent.code == 'Space'
    ) {
      e.preventDefault();
      this.onDealerSelect(dealer, index);
    }
  };

  static getDerivedStateFromProps = (props: any, state: any) => {
    let newState = {};

    if (state.dealers !== props.dealers) {
      const dealerPositions: {
        [key: string]: DealerInterface;
      } = {};

      props.dealers.forEach((dealer: DealerInterface) => {
        dealerPositions[`${dealer.latitude},${dealer.longitude}`] = dealer;
      });
      newState = {...newState, dealers: dealerPositions};
    }

    if (state.center !== props.center) {
      newState = {...newState, center: props.center};
    }

    if (props.currentLocale !== state.currentLocale) {
      newState = {...newState, currentLocale: props.currentLocale};
    }

    return Object.keys(newState).length === 0 ? null : newState;
  };

  renderDealerPoints = (dealers: DealerInterface[]) => {
    return dealers.map((dealer, index) => {
      const key = `${dealer.name}-${index}`;

      return (
        <Marker
          icon="https://vw-canada-websites.s3.amazonaws.com/feature-apps/common/marker_blue.png"
          key={key}
          position={{
            lat: Number(dealer.latitude),
            lng: Number(dealer.longitude),
          }}
          onClick={(e: google.maps.MapMouseEvent) =>
            this.onMarkerClick(dealer, key, e)
          }
        >
          {Number(this.state.selectedDealer) === Number(dealer.id) ? (
            <InfoWindow
              position={{
                lat: Number(dealer.latitude),
                lng: Number(dealer.longitude),
              }}
              onCloseClick={() => this.onMapClicked()}
            >
              <InfoDisplay>
                <Row>
                  <label className={'title'}>
                    {this.state.activeDealer.name}
                  </label>
                </Row>
                <Row>
                  <label>{this.state.activeDealer.address}</label>
                </Row>
                <Row>
                  <label>{this.state.activeDealer.city}</label>
                </Row>
                <Row>
                  <label>
                    {this.state.activeDealer.phone ||
                      this.state.activeDealer.fax}
                  </label>
                </Row>
              </InfoDisplay>
            </InfoWindow>
          ) : null}
        </Marker>
      );
    });
  };

  render() {
    const {
      dealers,
      requestLabel,
      placeholderDealersHeadline,
      center,
      searchMade,
      invalidZip,
      tracking,
      searchCallback,
    } = this.props;

    return (
      <FullWidthDiv className="full-width">
        {
          this.state.apiKey
          ? <MapContainer className="map-container">
              <LoadScript googleMapsApiKey={this.state.apiKey}>
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={10}
                  options={options}
                  onLoad={() => {
                    searchCallback('');
                    setTimeout(() => {
                      [].slice
                        .apply(
                          document.querySelectorAll(
                            '.map-container a, .map-container button, .map-container [role=button]',
                          ),
                        )
                        .forEach(function (item: HTMLElement) {
                          item.setAttribute('tabindex', '-1');
                        });
                      [].slice
                        .apply(
                          document.querySelectorAll('[aria-roledescription=map]'),
                        )
                        .forEach(function (item: HTMLElement) {
                          item.setAttribute('tabindex', '-1');
                          item.setAttribute('aria-hidden', 'true');
                        });
                    }, 2000);
                  }}
                  onClick={this.onMapClicked}
                  onIdle={() => {
                    setTimeout(() => {
                      [].slice
                        .apply(
                          document.querySelectorAll(
                            '.map-container a, .map-container button, .map-container [role=button]',
                          ),
                        )
                        .forEach(function (item: HTMLElement) {
                          item.setAttribute('tabindex', '-1');
                        });
                      [].slice
                        .apply(
                          document.querySelectorAll('[aria-roledescription=map]'),
                        )
                        .forEach(function (item: HTMLElement) {
                          item.setAttribute('tabindex', '-1');
                          item.setAttribute('aria-hidden', 'true');
                        });
                    }, 1000);
                  }}
                >
                  {!!dealers.length && this.renderDealerPoints(dealers)}
                </GoogleMap>
              </LoadScript>
            </MapContainer>
          : null
        }
        <DealerList className={'dealers-list-container'} tabIndex={-1}>
          <GeneralContainer>
            {!searchMade ? (
              <Text
                className="placeholder-dealers headline"
                appearance={TokenTextAppearance.headline400}
              >
                {placeholderDealersHeadline}
              </Text>
            ) : null}
            {dealers.map((dealer, index) => {
              const key = `${dealer.name}-${index}`;
              return (
                <DealerCard
                  key={key}
                  name={dealer.name}
                  id={dealer.id}
                  dealer={dealer}
                  locale={this.state.currentLocale}
                  requestLabel={requestLabel}
                  selectedDealer={this.state.selectedDealer}
                  onDealerSelect={() => this.onDealerSelect(dealer, index)}
                  keyDown={(e: KeyboardEvent) =>
                    this.onKeyDown(e, dealer, index)
                  }
                  searchMade={searchMade}
                  invalidZip={invalidZip}
                  firstDealer={dealers[0].id.toString()}
                  tracking={tracking}
                />
              );
            })}
          </GeneralContainer>
        </DealerList>
      </FullWidthDiv>
    );
  }
}

export default React.memo(LocatorMapContainer);
